export default __webpack_public_path__ + "static/media/lock-open.9ef7743f.svg";